import _ from "lodash";

export const getSelectedCountry = state => state.orderData[state.activeOrderDataIndex]['country'];

export const getPlanType = state => state.orderData[state.activeOrderDataIndex]['plan_type'];

export const getStartDate = state => state.orderData[state.activeOrderDataIndex]['start_date'];

export const getNumberOfDays = state => state.orderData[state.activeOrderDataIndex]['number_of_days'];

export const getNumberOfDevices = state => state.orderData[state.activeOrderDataIndex]['number_of_devices'];

export const getSelectedPlan = state => state.orderData[state.activeOrderDataIndex]['plan'];

export const getShipmentType = state => state.orderData[state.activeOrderDataIndex]['shipment_type'];

export const getDeliveryType = state => state.orderData[state.activeOrderDataIndex]['delivery_type'];

export const getCoupon = state => state.orderData[state.activeOrderDataIndex]['coupon'];

export const getGiftCard = state => state.orderData[state.activeOrderDataIndex]['gift_card'];

export const getInsuranceStatus = state => state.orderData[state.activeOrderDataIndex]['insurance_status'];
export const getUsaStates = state => state.usaStates;
export const getCountryPackages = state => state.countryPackages;

export const getPlanDevices = (state, getters) => {
    let devices = state.planDevices;
    let orders = getters.getOrderData;
    let activeOrderIndex = getters.getActiveOrderDataIndex;
    let order = orders[activeOrderIndex];

    if (order.plan_type === 'day') {
        devices = devices.filter(device => device.plan_type === 'day');
    }

    if (order.plan_type === 'month') {
        devices = devices.filter(device => device.plan_type === 'month');
    }

    return devices;
};

export const getActiveOrderDataIndex = state => state.activeOrderDataIndex;

export const getOrderData = state => state.orderData;
export const getSelectedDevice = state => state.selectedDevice;
export const getSelectedDeviceExtraCharge = state => state.orderData[state.activeOrderDataIndex]['device_extra_charge'];

export const getCouponDiscountAmount = (state, getters) => {
    const orders = getters.getOrderData;
    const activeOrderIndex = getters.getActiveOrderDataIndex;
    const order = orders[activeOrderIndex];
    const price = getters.getOrderSubtotalAmount;
    const couponId = order.coupon_id;
    const couponType = order.coupon_type;
    const couponDiscountAmount = order.coupon_discount_amount;

    let discountAmount = 0;

    if (couponId) {
        if (state.couponTypes[1].tag === couponType) {
            discountAmount = couponDiscountAmount;
        } else if (state.couponTypes[2].tag === couponType) {
            discountAmount = Math.round(price * couponDiscountAmount) / 100;
        }
    }

    return discountAmount;
};

export const getGiftCardDiscount = (state, getters) => {
    const orders = getters.getOrderData;
    const activeOrderIndex = getters.getActiveOrderDataIndex;
    const order = orders[activeOrderIndex];

    let discountAmount = 0;

    // if (order.gift_card_id) {
    //     discountAmount = order.gift_discount_amount;
    // }

    return discountAmount;
};

export const getInsuranceAmount = (state, getters) => {
    const numberOfDevices = getters.getNumberOfDevices;
    const numberOfDays = getters.getNumberOfDays;
    let amount = 0;

    if (getters.getInsuranceStatus) {
        amount = numberOfDays * state.insurance_amount * numberOfDevices;
    }

    return amount;
};

export const getDeliveryPrice = (state, getters) => {
    let price = 0;
    let orderData = state.orderData[state.activeOrderDataIndex];
    let orderSubtotalAmount = getters.getOrderSubtotalAmount;
    let couponDiscountAmount = getters.getCouponDiscountAmount;
    let totalPrice = orderSubtotalAmount - couponDiscountAmount;

    if (orderData.shipment_type === 'delivery' && orderData.delivery_type_id) {
        price += orderData.delivery_type_charges;

        if (totalPrice >= 99 && orderData.delivery_type_id === 2) {
            price = 0
        }
    }

    return price;
};

export const getTotalAmountForDeviceExtraCharge = (state, getters) => {
    let totalAmount = 0;
    let orders = getters.getOrderData;
    let activeOrderIndex = getters.getActiveOrderDataIndex;
    let order = orders[activeOrderIndex];
    let numberOfDays = order.number_of_days;
    let numberOfDevices = order.number_of_devices;
    let selectedDeviceExtraCharge = getters.getSelectedDeviceExtraCharge;

    if (order.device_type === '2' /* 5G */ && order.plan_type === 'day') {
        for (let i = 1; i <= numberOfDays; i++) {
            if (i <= 15) {
                totalAmount += 3;
            } else {
                totalAmount += 2;
            }
        }
        totalAmount = totalAmount * numberOfDevices;
    } else {
        totalAmount = selectedDeviceExtraCharge * numberOfDevices;
    }

    return totalAmount;
}

export const getOrderSubtotalAmount = (state, getters) => {
    const orders = getters.getOrderData;
    const activeOrderIndex = getters.getActiveOrderDataIndex;
    const order = orders[activeOrderIndex];
    const numberOfDevices = order.number_of_devices;
    const numberOfDays = order.number_of_days;
    const country_api_id = order.country_api_id;
    const plan_id = order.plan_id;
    const plan_amount = order.plan_amount;

    let amount = 0;

    if (!plan_id) {
        return amount;
    }

    for (let i = 1; i <= numberOfDays; i++) {
        switch (true) {
            case country_api_id === 198:
                if (i <= 10) {
                    amount += plan_amount;
                } else if (i <= 20) {
                    amount += 7;
                } else {
                    amount += 2.5;
                }
                break;
            case country_api_id === 180:
                if (i <= 10) {
                    amount += plan_amount;
                } else if (i <= 20) {
                    amount += 7;
                } else {
                    amount += 2.5;
                }
                break;
            default:
                if (i <= 10) {
                    amount += plan_amount;
                } else {
                    amount += plan_amount - 3;
                }
        }
    }

    amount = amount * numberOfDevices;
    return Math.round(amount * 100) / 100;
};

export const getOrderTotalAmount = (state, getters) => {
    let totalAmount = 0;

    let giftCardDiscount = getters.getGiftCardDiscount;
    let deliveryPrice = getters.getDeliveryPrice;
    let insuranceAmount = getters.getInsuranceAmount;
    let orderSubtotalAmount = getters.getOrderSubtotalAmount;
    let couponDiscountAmount = getters.getCouponDiscountAmount;
    let selectedDeviceExtraCharge = getters.getTotalAmountForDeviceExtraCharge;
    let numberOfDevices = getters.getNumberOfDevices;

    totalAmount = orderSubtotalAmount + deliveryPrice + insuranceAmount;

    if (selectedDeviceExtraCharge) {
        totalAmount += parseFloat(selectedDeviceExtraCharge);
    }

    totalAmount = totalAmount - couponDiscountAmount - giftCardDiscount;
    totalAmount = totalAmount < 0 ? 0 : totalAmount;

    let orderData = _.cloneDeep(state.orderData);
    orderData[state.activeOrderDataIndex]['total_amount'] = totalAmount;
    state.orderData = orderData;

    return totalAmount;
};

export const getPickupLocationsForDropdown = (state) => {
    let locationsData = [
        {
            "label": "Airport Locations",
            "value": "airport",
            "menu": []
        },
        {
            "label": "Other Locations",
            "value": "other",
            "menu": []
        },
    ];

    let airportLocationIds = [353, 365, 386];

    _.forEach(state.pickupLocations, function(location) {
        if (_.includes(airportLocationIds, location.api_pickup_location_id)) {
            locationsData[0]["menu"].push({
                "label": location.name,
                "value": location.api_pickup_location_id,
            });
        } else {
            locationsData[1]["menu"].push({
                "label": location.name,
                "value": location.api_pickup_location_id,
            });
        }
    });

    let disabledLocation = [
        'Miami (MIA)',
        'Atlanta (ATL)',
        'Houston (IAH)',
        'Dallas (DFW)',
        'Dulles (IAD)',
        'Boston (BOS)',
    ];

    _.forEach(disabledLocation, function(location) {
        locationsData[0]["menu"].push({
            "label": location + ': coming soon',
            "value": null,
            "disabled": true,
        });
    });

    return locationsData;
};
